import { render } from "./HandicapTile.vue?vue&type=template&id=f819a75a&scoped=true"
import script from "./HandicapTile.vue?vue&type=script&lang=js"
export * from "./HandicapTile.vue?vue&type=script&lang=js"

import "./HandicapTile.vue?vue&type=style&index=0&id=f819a75a&scoped=true&lang=css"

import exportComponent from "/Users/vincentblin/Sites/ONET-WA/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f819a75a"]])

export default __exports__